import React from "react";
import get from "lodash/get";
import { ProfileImage } from "../profile-image";
import EntityShare from "../entity-share/entity-share";
import { Link } from "@quintype/components";
import "./entity-details.m.css";

export const ProfileTopCompanies = ({ item, entityName, sketchesHost }) => {
  const profileImg = get(item, ["logo"], []);
  const persons = item?.["key-persons"];
  const profileUrl = sketchesHost + "/companies/" + item?.slug;
  return (
    <div styleName="entity-details-header companies">
      <div styleName="profile-content">
        <div styleName="profile-content-left">
          <h1 styleName="headline">{item?.name}</h1>
          <p styleName="sub-headline">{item?.tagline}</p>
        </div>
        <div styleName="profile-content-rt">
          <EntityShare title={item?.name} url={profileUrl} />
        </div>
      </div>
      <div styleName="profile-image">
        <ProfileImage imageUrl={profileImg} entityName={entityName} />
      </div>
      <div styleName="entity-meta-data">
        {item?.industry && (
          <div styleName="row-data">
            <span>Industry:</span>
            {item?.industry}
          </div>
        )}
        {item?.["year-founded"] && (
          <div styleName="row-data">
            <span>Year Founded:</span>
            {item?.["year-founded"]}
          </div>
        )}
        {item?.["headquarters-location"] && (
          <div styleName="row-data">
            <span>Headquarters Location:</span>
            {item?.["headquarters-location"]}
          </div>
        )}
        {persons?.name && (
          <div styleName="row-data">
            <span>Key Person:</span>
            <Link href={`/people/${persons?.slug}`}>{persons.name}</Link>
          </div>
        )}
        {item?.["major-achievements"] && (
          <div styleName="row-data">
            <span>Major Achievements:</span>
            {item?.["major-achievements"]}
          </div>
        )}
        {item?.website && (
          <div styleName="row-data">
            <span>Website:</span>
            <a href={item?.website} target="_blank" rel="noreferrer">
              {item?.website}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
